import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const FolderAreaIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="folderArea" ref={ref} {...props}>
      <path d="M9,10.249H5A3.758,3.758,0,0,0,1.246,14v4A3.758,3.758,0,0,0,5,21.749H9A3.751,3.751,0,0,0,12.746,18V14A3.751,3.751,0,0,0,9,10.249ZM11.246,18A2.253,2.253,0,0,1,9,20.249H5A2.253,2.253,0,0,1,2.746,18V14A2.253,2.253,0,0,1,5,11.749H9A2.253,2.253,0,0,1,11.246,14Zm10.37-8.52v7.37a3.606,3.606,0,0,1-3.61,3.6h-3.83v-1.5h3.83a2.108,2.108,0,0,0,2.11-2.1V9.479a2.117,2.117,0,0,0-2.11-2.11h-4.84a.749.749,0,0,1-.53-.22l-2.11-2.1H6a2.108,2.108,0,0,0-2.11,2.1v1.53h-1.5V7.149A3.613,3.613,0,0,1,6,3.549h4.84a.749.749,0,0,1,.53.22l2.11,2.1h4.53A3.615,3.615,0,0,1,21.616,9.479Zm-13.87,3.77A.75.75,0,1,1,7,12.5.749.749,0,0,1,7.746,13.249Zm0,5.5a.75.75,0,0,1-1.5,0,.75.75,0,0,1,1.5,0ZM5,16a.75.75,0,0,1-1.5,0A.75.75,0,1,1,5,16Zm2.75-.08a.75.75,0,1,1-.75-.75A.749.749,0,0,1,7.746,15.919Zm2.76.08a.75.75,0,1,1-.75-.75A.749.749,0,0,1,10.506,16Z" />
    </Icon>
  ),
) as IconWithRender;

FolderAreaIcon.displayName = 'FolderAreaIcon';
FolderAreaIcon.renderIcon = (props) => <FolderAreaIcon {...props} />;
export default FolderAreaIcon;
